module.exports = __webpack_public_path__ + "img/suit-04.b3ee5665.png";